import { action, computed } from 'mobx';
import { UpdateBorrowerSettingsRequest } from 'src/generated-api-client';
import { borrowerApi } from 'src/services/apiServices';
import { AsyncOperationWithStatus } from 'src/utils/mobx/AsyncOperationWithStatus';
import { RequestHelper } from 'src/utils/RequestHelper';

export class BorrowerSettingsStoreClass {
    borrowerSettingsLoader = new AsyncOperationWithStatus((...args) => {
        const options = RequestHelper.getOptionsFromArgs(args);

        return RequestHelper.unwrapFromAxiosPromise(
            borrowerApi.getBorrowerSettings(options),
        );
    });

    borrowerSettingsUpdateLoader = new AsyncOperationWithStatus(
        (settings: UpdateBorrowerSettingsRequest, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                borrowerApi.updateBorrowerSettings(
                    { updateBorrowerSettingsRequest: settings },
                    options,
                ),
            );
        },
    );

    @action
    loadSettings() {
        return this.borrowerSettingsLoader.call();
    }

    @action
    async updateSettings(settings: UpdateBorrowerSettingsRequest) {
        await this.borrowerSettingsUpdateLoader.call(settings);
    }

    @computed get settings() {
        return this.borrowerSettingsLoader.data?.borrowerSettings || {};
    }
}

export const BorrowerSettingsStore = new BorrowerSettingsStoreClass();
